import React from "react";
import { Flex, Span, Text } from "../../assets/ui";
import { StyledButton } from "../common/Button";
import { MdClose } from "react-icons/md";
import { StyledModalBodyWrapper } from "./ui";

const ThanksModal = ({ closeModal }) => {
  return (
    <StyledModalBodyWrapper p={"24px"} width={["90vw", "464px"]}>
      <Flex justifyContent="flex-end" width="100%" alignItems="center">
        <Span m="0 auto" pl="24px" color="#586981">
          Hello sent
        </Span>
        <Span cursor="pointer" height="24px" onClick={closeModal}>
          <MdClose size="24px" color="#233247" />
        </Span>
      </Flex>
      <Text
        textAlign="center"
        fontSize={"32px"}
        lineHeight={"40px"}
        fontWeight="bold"
        color="#233247"
        margin={["10px 0 30px", null, "46px 0 60px"]}
      >
        Thanks for reaching out!
      </Text>
      <Flex
        flexDirection="column"
        alignItems="center"
        maxWidth="280px"
        color="#586981"
      >
        <Span textAlign="center" fontSize="16px" lineHeight="20px">
          You will receive an automated email notifiying you that we have
          received your contact!
        </Span>
      </Flex>

      <StyledButton
        marginTop={["50px", null, "76px"]}
        mb={["18px", "34px"]}
        width={["208px", "256px"]}
        onClick={closeModal}
      >
        Done
      </StyledButton>
      <Flex
        flexDirection="column"
        fontSize={["24px"]}
        fontWeight="600"
        color="#233247"
        lineHeight={["28px"]}
        justifyContent="center"
        alignItems="center"
      >
        <Span>The future of</Span>
        <Span>
          <Span color="#ED3163">sports</Span> is now!
        </Span>
      </Flex>
    </StyledModalBodyWrapper>
  );
};

export default ThanksModal;
